<button class="accent transparent" mat-flat-button aria-hidden="true">
  waiting
  <mat-spinner [diameter]="20"></mat-spinner>
</button>
